'use client';

import { useEffect, useState } from 'react';
import DevToolsPanel from './DevToolsPanel';

import styles from './DevTools.module.css';

export default function DevTools() {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [showDevTools, setShowDevTools] = useState<boolean>(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const showDevTools = localStorage.getItem('showDevTools');

      if (showDevTools !== null) {
        queueMicrotask(() => setShowDevTools(true));
      }
    }
  }, []);

  if (!showDevTools) {
    return null;
  }

  return (
    <div className={styles.devTools}>
      {!isOpen && (
        <button
          onClick={() => {
            setIsOpen(true);
          }}
        >
          Dev Tools
        </button>
      )}

      {isOpen && <DevToolsPanel setIsOpen={setIsOpen} />}
    </div>
  );
}
